import React from 'react';
import { connect } from 'react-redux';
import './HashDemo.css';
import * as actions from '../actions.js';
import { hashTypes } from '../reducers/hasher.js';

import {
    Grid,
    PageHeader,
    Row,
    Col,
    DropdownButton,
    MenuItem,
    FormGroup,
    FormControl,
    ControlLabel,
} from 'react-bootstrap';


function HashDigit({ n }) {
    return <div className={`hashdigit sixteencolour${n}`}>{ n }</div>;
}

function HashDisplay({ hashOutput, hashOutputType }) {
    if( !hashOutput ) {
        return <div className="hashoutput inactive">output will display here</div>;
    }
    const segments = [],
        size = hashOutput.length / 16;
    for( let i = 0; i < size; i++ ) {
        const start = i * 16,
            end = start + 16;
        segments.push( hashOutput.slice(start, end) );
    }
    if( hashOutputType === 'text' ) {
        return <div className="hashoutput">
            {
                segments.map((s, i) => <div className="hashoutputline" key={'hash-output-text'+i}>{ s }</div>)
            }
        </div>;
    }
    return <div className="hashoutput">
        {
            segments.map((s, i) =>
                <div className="hashoutputline" key={'hash-output-segment'+i}>{
                    s.split('').map((d, j) =>
                        <HashDigit n={d} key={'d'+i+'x'+j} />)
                }</div>)
        }
    </div>;
}

//TODO: style file input button here and in merkle demo http://geniuscarrier.com/how-to-style-a-html-file-upload-button-in-pure-css/

function HashDemo({
    hashInput,
    hashOutput,
    hashType,
    hashOutputType,
    changeInput,
    changeHashType,
    changeOutputType,
    selectFile
}) {
    return (
        <Grid>
            <PageHeader>
                Hash Function Demonstration
            </PageHeader>
            <Row>
                <Col sm={5}>
                    <h2>Input</h2>
                    <textarea
                        id="hashinput"
                        name="hashinput"
                        className="hashinput"
                        rows="2"
                        placeholder="type something here"
                        value={hashInput}
                        onChange={ev => changeInput(ev.target.value)}
                    ></textarea>
                    <hr />
                    <FormGroup controlId="hashFileInput">
                        <ControlLabel>Or select a file</ControlLabel>
                        <FormControl type="file" onChange={ev => {console.log('change', ev.target.value);selectFile(ev);}} />
                    </FormGroup>
                </Col>
                <Col sm={2} className="hashinbetween">
                    <h2 className="hasharrowheader">🡺</h2>
                    <DropdownButton bsStyle="catallaxy" id="hashselector" title={hashType} onSelect={nt => changeHashType(nt)}>
                        {
                            hashTypes.map(ht => <MenuItem active={ht === hashType} eventKey={ht} key={'select-'+ht}>{ ht }</MenuItem>)
                        }
                    </DropdownButton>
                </Col>
                <Col sm={5}>
                    <h2 className="output-h2">Output</h2>
                    <DropdownButton id="hashoutputselector" title="output" bsSize="xsmall" bsStyle="catallaxy" onSelect={nt => changeOutputType(nt)}>
                        <MenuItem eventKey="text" active={hashOutputType === 'text'}>text</MenuItem>
                        <MenuItem eventKey="color" active={hashOutputType === 'color'}>color</MenuItem>
                    </DropdownButton>
                    <HashDisplay hashOutput={hashOutput} hashOutputType={hashOutputType} />
                </Col>
            </Row>
        </Grid>
    );
}

function stateToProps({ hash }) {
    return {
        hashInput: hash.hashInput || "",
        hashOutput: hash.hashOutput || "",
        hashType: hash.hashType,
        hashOutputType: hash.hashOutputType || "text",
    };
}
function dispatchToProps(dispatch) {
    return {
        changeInput(val) {
            dispatch(actions.changeInput(val));
        },
        changeHashType(newType) {
            dispatch(actions.changeHashType(newType));
        },
        changeOutputType(newType) {
            dispatch(actions.changeOutputType(newType));
        },
        selectFile(evt) {
            const reader = new FileReader();
            reader.onload = function fileReadIn(ev) {
                dispatch(actions.selectedFile(ev.target.result));
            };
            reader.readAsText( evt.target.files[0] );
        },
    };
}

export default connect(stateToProps, dispatchToProps)(HashDemo);





// WEBPACK FOOTER //
// ./src/components/HashDemo.js